module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"elHeader":"Stromkonfiguration","containerNote":"Das gewählte Stromprodukt wird für den Stromverbrauch (Allgemeinstrom und Mieterstrom) und für alle Heizungstypen mit dem Energieträger \u0027In der Liegenschaft definiertes Stromprodukt (Netz)\u0027 oder \u0027In der Liegenschaft definiertes Stromprodukt (Netz+PV)\u0027 verwendet.","gridTitle":"Netzbezug","pvTitle":"PV-Anlage"}}')
  delete Component.options._Ctor
}
